import { render, staticRenderFns } from "./keywordRanking.vue?vue&type=template&id=2c2e0fc0&scoped=true"
import script from "./keywordRanking.vue?vue&type=script&lang=js"
export * from "./keywordRanking.vue?vue&type=script&lang=js"
import style0 from "./keywordRanking.vue?vue&type=style&index=0&id=2c2e0fc0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c2e0fc0",
  null
  
)

export default component.exports